import { render } from "./trust-data-external-examiner-approval.html?vue&type=template&id=88dfa044&scoped=true&ts=true&external"
import script from "./trust-data-external-examiner-approval.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-external-examiner-approval.ts?vue&type=script&lang=ts&external"

import "./trust-data-external-examiner-approval.scss?vue&type=style&index=0&id=88dfa044&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dfa044"]])

export default __exports__